function generateStars() {
  const stars = [];
  // 50 twinkling stars
  for (let i = 0; i < 50; i++) {
    stars.push({
      id: `s${i}`,
      left: `${(Math.random() * 100).toFixed(2)}%`,
      top: `${(Math.random() * 100).toFixed(2)}%`,
      width: `${(Math.random() * 2.2 + 0.8).toFixed(1)}px`,
      height: `${(Math.random() * 2.2 + 0.8).toFixed(1)}px`,
      delay: `${(Math.random() * 6).toFixed(1)}s`,
      duration: `${(2 + Math.random() * 4).toFixed(1)}s`,
      twinkle: true,
    });
  }
  // 100 static faint background stars
  for (let i = 0; i < 100; i++) {
    const sz = `${(Math.random() * 1.4 + 0.3).toFixed(1)}px`;
    stars.push({
      id: `sf${i}`,
      left: `${(Math.random() * 100).toFixed(2)}%`,
      top: `${(Math.random() * 100).toFixed(2)}%`,
      width: sz,
      height: sz,
      opacity: Number((Math.random() * 0.5 + 0.06).toFixed(2)),
      twinkle: false,
    });
  }
  return stars;
}

export const STARS = generateStars();

export default function StarsBackground() {
  return (
    <div id="space">
      {STARS.map((s) => (
        <div
          key={s.id}
          className="star"
          style={{
            left: s.left,
            top: s.top,
            width: s.width,
            height: s.height,
            willChange: s.twinkle ? "opacity, transform" : "auto",
            ...(s.twinkle
              ? { animationDelay: s.delay, animationDuration: s.duration }
              : { opacity: s.opacity, animation: "none" }),
          }}
        />
      ))}
    </div>
  );
}
